export default __webpack_public_path__ + "static/media/img_delivery_c.7a05a30f.webp";